import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import Dasboard from './apps/dashboard/App';
import Auth from './apps/auth/App';
import { paths as dashboardPaths } from './apps/dashboard/routes';
import { pathTemplates as authPaths } from './apps/auth/routes';
import { useCurrentLocale } from './context/I18n';
import moment from 'moment';
import { Helmet } from 'react-helmet-async';
import { AuthProvider } from './context/AuthContext';
import { SkeletonTheme } from 'react-loading-skeleton';
import { Theme } from './theme';
import { withChildren } from './utils/react';

const SkeletonThemeWithChildren = withChildren(SkeletonTheme);
const RouterWithChildren = withChildren(Router);

const App: React.FC<React.PropsWithChildren<unknown>> = () => {
  const locale = useCurrentLocale();
  moment.locale(locale);

  return (
    <>
      <Helmet>
        <html lang={locale} />
      </Helmet>
      <SkeletonThemeWithChildren
        color={Theme.color.paper4}
        highlightColor={Theme.color.paper5}>
        {/*
          StrictMode is deliberately NOT enabled. Its dev-only
          mount -> unmount -> remount cycle breaks two core dependencies that
          latch state in refs on unmount and never re-initialise on remount:

            - react-hook-form v5 sets `isUnMount.current = true` in its unmount
              cleanup, which permanently turns `reRender()` into a no-op. Every
              form in the app then stops re-rendering on field changes (stale
              `watch()` values, dead cross-field validation, dependent inputs
              never updating). See App.strictmode-react-hook-form.test.tsx.
            - react-router v5's Router subscribes to history in its constructor
              and detaches in componentWillUnmount, so client-side navigation
              dies. See App.router-strictmode.test.tsx.

          Both are dev-only, but they make the app untestable in development.
          Re-enable StrictMode once react-hook-form and react-router are
          upgraded to StrictMode-safe versions (v7 / v6 respectively).
        */}
        <RouterWithChildren>
          <AuthProvider>
            <Switch>
              <Route path={authPaths}>
                <Auth />
              </Route>
              <Route path={dashboardPaths}>
                <Dasboard />
              </Route>
            </Switch>
          </AuthProvider>
        </RouterWithChildren>
      </SkeletonThemeWithChildren>
    </>
  );
};

export default App;
